import { render } from "./partsStockList.vue?vue&type=template&id=5acc9f97&scoped=true&ts=true"
import script from "./partsStockList.vue?vue&type=script&lang=ts"
export * from "./partsStockList.vue?vue&type=script&lang=ts"

import "./partsStockList.vue?vue&type=style&index=0&id=5acc9f97&lang=scss"
import "./partsStockList.vue?vue&type=style&index=1&id=5acc9f97&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acc9f97"]])

export default __exports__